/**
 * @generated SignedSource<<ea35aa4a49a83c80ced2f6ab4cee71d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateAccountInput = {
  name?: string | null;
  supportEmail?: string | null;
  autoCloseDays?: number | null;
  slug?: string | null;
  ticketNumberNext?: number | null;
  responseSlaValue?: number | null;
  responseSlaUnit?: string | null;
  resolutionSlaValue?: number | null;
  resolutionSlaUnit?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useUpdateAccountMutation$variables = {
  input: UpdateAccountInput;
};
export type useUpdateAccountMutation$data = {
  readonly updateAccount: {
    readonly clientMutationId: string | null;
    readonly account: {
      readonly id: string;
      readonly autoCloseDays: number | null;
      readonly inboundLocalPart: string | null;
      readonly supportEmailDomainConfigured: boolean | null;
      readonly slug: string | null;
      readonly ticketNumberNext: number | null;
      readonly responseSlaValue: number | null;
      readonly responseSlaUnit: string | null;
      readonly resolutionSlaValue: number | null;
      readonly resolutionSlaUnit: string | null;
    } | null;
  } | null;
};
export type useUpdateAccountMutation = {
  variables: useUpdateAccountMutation$variables;
  response: useUpdateAccountMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAccountPayload",
    "kind": "LinkedField",
    "name": "updateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketingAccount",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoCloseDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inboundLocalPart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "supportEmailDomainConfigured",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ticketNumberNext",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseSlaValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseSlaUnit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolutionSlaValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolutionSlaUnit",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateAccountMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "15824a70d39c9762f2d4fac3b06e29ef",
    "id": null,
    "metadata": {},
    "name": "useUpdateAccountMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateAccountMutation(\n  $input: UpdateAccountInput!\n) {\n  updateAccount(input: $input) {\n    clientMutationId\n    account {\n      id\n      autoCloseDays\n      inboundLocalPart\n      supportEmailDomainConfigured\n      slug\n      ticketNumberNext\n      responseSlaValue\n      responseSlaUnit\n      resolutionSlaValue\n      resolutionSlaUnit\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5b6feea748f27dd5f92126b80bb78c9";

export default node;
